import React, { Component } from 'react';
import Modal from 'react-awesome-modal';
import PrismaZoom from 'react-prismazoom'
import { getImagesFilePath } from '../components/UserFunctions'
import PropTypes from 'prop-types';

export default class ReviewPanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      current_id : 1,
      image_list : [],
      visible : false,
      image : [],
      b_rects: [],
      gt_rects: [],
    }
  }

  openModal() {
    this.setState({
      visible : true,
    });
    this.updateCanvasB()
  }

  closeModal() {
    this.setState({
      visible : false
    });
  }

  nextImage = (id1) => {
    const baseUrl = "data:image/png;base64,";
     this.state.image_list.forEach(({id, src, bench_bbox_list,gt_bbox_list}) => {
			if(id1===id){
				this.setState({
          image :  `${baseUrl}${src}`,
          current_id : id1,
          b_rects : bench_bbox_list,
          gt_rects : gt_bbox_list
        });
			}
		})
	

  }

  prevImage = (id1) => {
    const baseUrl = "data:image/png;base64,";
     this.state.image_list.forEach(({id, src, bench_bbox_list,gt_bbox_list}) => {
			if(id1===id){
          this.setState({
            image :  `${baseUrl}${src}`,
            current_id : id1,
            b_rects : bench_bbox_list,
            gt_rects : gt_bbox_list
          });
			}
		})
	
  }

  convert_coords = (rect1,img_w,img_h,canv_w,canv_h) => {
    var new_rect = []
    var x1 = (canv_w/img_w)*rect1[0]
    var y1 = (canv_h/img_h)*rect1[1]
    var x2 = (canv_w/img_w)*rect1[2]
    var y2 = (canv_h/img_h)*rect1[3]
    var h = y2 - y1
    var w = x2 - x1
    new_rect = [Math.round(x1),Math.round(y1),Math.round(w),Math.round(h)]
    return new_rect
  }

  updateCanvasB(){
    const canvasB = this.canvasB
    // canvasB.width = 1000
    // canvasB.height = 560
    const ctx = canvasB.getContext("2d")
    var img = new Image()
    img.src = this.state.image
    img.onload = () => {
    ctx.drawImage(img,0,0,canvasB.width,canvasB.height)
    ctx.beginPath();
    ctx.strokeStyle="blue";
    for(var i=0;i<this.state.b_rects.length;i++) {
      var new_rect = this.convert_coords(this.state.b_rects[i],img.width,img.height,canvasB.width,canvasB.height)
      ctx.rect(new_rect[0],
      new_rect[1],
      new_rect[2],
      new_rect[3]);
    }
    ctx.stroke();

    ctx.beginPath();
    ctx.strokeStyle="green";
    for(i=0;i<this.state.gt_rects.length;i++) {
      new_rect = this.convert_coords(this.state.gt_rects[i],img.width,img.height,canvasB.width,canvasB.height)
      ctx.rect(new_rect[0],
      new_rect[1],
      new_rect[2],
      new_rect[3]);
    }
    ctx.stroke();
    }

  }

  updateCanvasA(){
    const canvasA = this.canvasA
    // canvasA.width = 295
    // canvasA.height = 160
    const ctx = canvasA.getContext("2d")
    var img = new Image()
    img.src = this.state.image
    img.onload = () => {
    ctx.drawImage(img,0,0,canvasA.width,canvasA.height)
    ctx.beginPath();
    ctx.strokeStyle="blue";
    for(var i=0;i<this.state.b_rects.length;i++) {
      var new_rect = this.convert_coords(this.state.b_rects[i],img.width,img.height,canvasA.width,canvasA.height)
      ctx.rect(new_rect[0],
      new_rect[1],
      new_rect[2],
      new_rect[3]);
    }
    ctx.stroke();

    ctx.beginPath();
    ctx.strokeStyle="green";
    for(i=0;i<this.state.gt_rects.length;i++) {
      new_rect = this.convert_coords(this.state.gt_rects[i],img.width,img.height,canvasA.width,canvasA.height)
      ctx.rect(new_rect[0],
      new_rect[1],
      new_rect[2],
      new_rect[3]);
    }
    ctx.stroke();
    }

  }
  // updateCanvasB(){
  //   const canvasB = this.canvasB
  //   // canvasB.width = 1000
  //   // canvasB.height = 560
  //   const ctx = canvasB.getContext("2d")
  //   var img = new Image()
  //   img.src = this.state.image
  //   img.onload = () => {
  //   ctx.drawImage(img,0,0,canvasB.width,canvasB.height)
  //   ctx.beginPath();
  //   ctx.strokeStyle="blue";
  //   for(var i=0;i<this.state.b_rects.length;i++) {
  //     var new_rect = this.convert_coords(this.state.b_rects[i],img.width,img.height,canvasB.width,canvasB.height)
  //     ctx.rect(new_rect[0],
  //     new_rect[1],
  //     new_rect[2],
  //     new_rect[3]);
  //   }
  //   ctx.stroke();

  //   ctx.beginPath();
  //   ctx.strokeStyle="green";
  //   for(var i=0;i<this.state.gt_rects.length;i++) {
  //     var new_rect = this.convert_coords(this.state.gt_rects[i],img.width,img.height,canvasB.width,canvasB.height)
  //     ctx.rect(new_rect[0],
  //     new_rect[1],
  //     new_rect[2],
  //     new_rect[3]);
  //   }
  //   ctx.stroke();
  //   }

  // }

  // updateCanvasA(){
  //   const canvasA = this.canvasA
  //   // canvasA.width = 295
  //   // canvasA.height = 160
  //   const ctx = canvasA.getContext("2d")
  //   var img = new Image()
  //   img.src = this.state.image
  //   img.onload = () => {
  //   ctx.drawImage(img,0,0,canvasA.width,canvasA.height)
  //   ctx.beginPath();
  //   ctx.strokeStyle="blue";
  //   for(var i=0;i<this.state.b_rects.length;i++) {
  //     var new_rect = this.convert_coords(this.state.b_rects[i],img.width,img.height,canvasA.width,canvasA.height)
  //     ctx.rect(new_rect[0],
  //     new_rect[1],
  //     new_rect[2],
  //     new_rect[3]);
  //   }
  //   ctx.stroke();

  //   ctx.beginPath();
  //   ctx.strokeStyle="green";
  //   for(var i=0;i<this.state.gt_rects.length;i++) {
  //     var new_rect = this.convert_coords(this.state.gt_rects[i],img.width,img.height,canvasA.width,canvasA.height)
  //     ctx.rect(new_rect[0],
  //     new_rect[1],
  //     new_rect[2],
  //     new_rect[3]);
  //   }
  //   ctx.stroke();
  //   }

  // }


  componentDidMount(){
    // var scene_id = {scene_id:'cc8c0bf57f984915a77078b10eb33198'}
    const baseUrl = "data:image/png;base64,";

    getImagesFilePath().then(res => {
        console.log(res);
        if(res !== undefined && res.data.length > 0){

                this.setState({
                    image_list : res.data.data,
                    b_rects : res.data.data[0]['bench_bbox_list'],
                    gt_rects : res.data.data[0]['gt_bbox_list'],
                    image :  `${baseUrl}${res.data.data[0]['src']}`
                })

      }
    });
    }

  componentDidUpdate(prevProps, prevState) {

    if (prevState.image !== this.state.image) {
      this.updateCanvasA()
      this.updateCanvasB()
    }
  }

  UNSAFE_componentWillReceiveProps (newProps) {
    const baseUrl = "data:image/png;base64,";
    // console.log(newProps)
    if( newProps.run_id !== this.props.run_id ){
      var runid_json = {run_id:newProps.run_id}
      getImagesFilePath(runid_json).then(res => {
        if(res !== undefined){

                this.setState({
                    image_list : res.data.data,
                    b_rects : res.data.data[0]['bench_bbox_list'],
                    gt_rects : res.data.data[0]['gt_bbox_list'],
                    image :  `${baseUrl}${res.data.data[0]['src']}`
                })
            
      }
    });
    }
  }

  render() {
    return (
      <section data-test = 'reviewPanelComponent'>
      {this.state.image_list !== undefined?
      <div>
        <div >
          <canvas  ref={`canvasA`} onClick={() => this.openModal() } style={{width : "100%", height:"100%"}}/>
        </div>
        <Modal visible={this.state.visible} width="1000" height="600" effect="fadeInRight" onClickAway={() => this.closeModal()}>
          <div>
            <h2>Review Panel
              &nbsp;&nbsp;Frame No: {this.state.current_id} &nbsp;&nbsp;
              <button href="#" onClick={() => this.prevImage(this.state.current_id-1)}>&nbsp;&nbsp;prev</button>
              <button href="#" onClick={() => this.nextImage(this.state.current_id+1)}>&nbsp;&nbsp;next</button>
              <button href="#" onClick={() => this.closeModal()}>&nbsp;&nbsp;Close</button>
            </h2>
            <PrismaZoom>
              <canvas ref={`canvasB`} style={{width : "100%", height:"100%"}}/>
            </PrismaZoom>
          </div>
        </Modal>
        </div>
        :<div className="alert alert-secondary" role="alert">
          No data available
        </div>}
      </section>
    );
  }
}
ReviewPanel.propTypes={
run_id:PropTypes.string,
}
ReviewPanel.defaultProps= {
run_id:[],
}